import React from "react";
import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  ogImage?: string;
  children?: React.ReactNode;
}

export const SEO: React.FC<SEOProps> = ({ title, description, ogImage, children }) => {
  return (
    <Helmet>
      <title>{title} | Scico</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage || "/og-default.png"} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      {children}
    </Helmet>
  );
};

export default SEO;
